import React, { useEffect, useState } from "react";
import { apiGet, apiDel, apiPostForm, apiPutForm } from "../../admin/api";
import Editor from "../../admin/components/Editor";
import WebSolutionsCard from "./WebSolutionsCard";
import "./websolutions-admin.css";

export default function WebSolutionsList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ id: null, title: "", excerpt: "", status: "published", content_html: "" });
  const [cover, setCover] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await apiGet("/api/websolutions?status=&page=1&limit=100");
      setRows(data.items || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const startNew = () => {
    setForm({ id: null, title: "", excerpt: "", status: "published", content_html: "" });
    setCover(null);
    setShowForm(true);
  };

  const startEdit = (r) => {
    setForm({
      id: r.id,
      title: r.title,
      excerpt: r.excerpt || "",
      status: r.status || "published",
      content_html: r.content_html || ""
    });
    setCover(null);
    setShowForm(true);
  };

  const save = async (e) => {
    e.preventDefault();
    const payload = {
      title: form.title,
      excerpt: form.excerpt,
      status: form.status,
      content_html: form.content_html
    };
    if (cover) payload.cover_image = cover;

    if (form.id) {
      await apiPutForm(`/api/websolutions/${form.id}`, payload);
    } else {
      await apiPostForm(`/api/websolutions`, payload);
    }
    setShowForm(false);
    await load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    await apiDel(`/api/websolutions/${id}`);
    await load();
  };

  return (
    <div className="websolutions-admin">
      <div className="websolutions-toolbar">
        <h2 className="websolutions-toolbar__title">Web Solutions</h2>
        <button className="websolutions-btn websolutions-btn--cta" onClick={startNew}>
          + New
        </button>
      </div>

      {loading ? (
        <div className="websolutions-empty">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="websolutions-empty-block">
          <div className="websolutions-empty-block__icon">🌐</div>
          <div className="websolutions-empty-block__title">No web solutions yet</div>
          <div className="websolutions-empty-block__desc">Click “New” to add your first item.</div>
        </div>
      ) : (
        <div className="websolutions-grid">
          {rows.map((r) => (
            <WebSolutionsCard key={r.id} item={r} onEdit={startEdit} onDelete={remove} />
          ))}
        </div>
      )}

      {showForm && (
        <div className="websolutions-modal" role="dialog" aria-modal="true">
          <div className="websolutions-modal__backdrop" onClick={() => setShowForm(false)} />

          <div className="websolutions-modal__card" role="document">
            <div className="websolutions-modal__head">
              <h3 className="websolutions-modal__title">
                {form.id ? "Edit Web Solution" : "New Web Solution"}
              </h3>
              <button className="websolutions-btn websolutions-btn--close" onClick={() => setShowForm(false)}>
                ×
              </button>
            </div>

            <form onSubmit={save} className="websolutions-form">
              <label className="websolutions-field">
                <span className="websolutions-field__label">Title</span>
                <input
                  className="websolutions-field__input"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  required
                />
              </label>

              <label className="websolutions-field">
                <span className="websolutions-field__label">Excerpt</span>
                <input
                  className="websolutions-field__input"
                  value={form.excerpt}
                  onChange={(e) => setForm({ ...form, excerpt: e.target.value })}
                />
              </label>

              <div className="websolutions-row">
                <label className="websolutions-field websolutions-grow">
                  <span className="websolutions-field__label">Status</span>
                  <select
                    className="websolutions-field__input"
                    value={form.status}
                    onChange={(e) => setForm({ ...form, status: e.target.value })}
                  >
                    <option value="published">published</option>
                    <option value="draft">draft</option>
                  </select>
                </label>

                <label className="websolutions-field websolutions-grow">
                  <span className="websolutions-field__label">Cover Image</span>
                  <input
                    className="websolutions-field__input"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setCover(e.target.files?.[0] || null)}
                  />
                </label>
              </div>

              <label className="websolutions-field">
                <span className="websolutions-field__label">Content</span>
                <div className="websolutions-editor">
                  <Editor
                    value={form.content_html}
                    onChange={(html) => setForm({ ...form, content_html: html })}
                  />
                </div>
              </label>

              <div className="websolutions-modal__actions">
                <button
                  type="button"
                  className="websolutions-btn websolutions-btn--sm"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="websolutions-btn websolutions-btn--primary">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
